import { config as printifyConfig } from './printifyConfig';
import { config as dupliumConfig } from './dupliumConfig';

const EXTERNAL_CONNECTION_CONFIGS = [printifyConfig, dupliumConfig];

export { EXTERNAL_CONNECTION_CONFIGS };
